import Seo from "@/components/layout/seo";
import CampaignTimeline from "@/components/layout/campaign-timeline";
import { useDeferredPublicEnhancement } from "@/hooks/use-deferred-public-enhancement";
import Hero from "@/pages/home/_components/hero";
import { isSupportedLocale } from "@/i18n";
import { localizedAlternates, localizedPath } from "@/lib/routes";
import {
  organizationJsonLd,
  professionalServiceJsonLd,
  webSiteJsonLd,
} from "@/lib/structured-data";
import { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

const HomeBelowFold = lazy(
  () => import("@/pages/home/_components/home-below-fold"),
);

export default function HomePage() {
  const { t } = useTranslation("home");
  const { lng } = useParams<{ lng: string }>();
  const locale = isSupportedLocale(lng) ? lng : "it";
  const loadBelowFold = useDeferredPublicEnhancement(1_200);

  const services = [
    t("services.web.title", { defaultValue: "Siti web" }),
    t("services.ecommerce.title", { defaultValue: "E-commerce" }),
    t("services.marketing.title", { defaultValue: "Social marketing" }),
    t("services.seo.title", { defaultValue: "SEO" }),
    t("services.graphics.title", { defaultValue: "Grafica" }),
    t("services.printing.title", { defaultValue: "Stampa digitale" }),
  ];

  return (
    <>
      <Seo
        title={t("meta.title")}
        description={t("meta.description")}
        path={localizedPath("home", locale)}
        locale={locale}
        routeKey="home"
        alternates={localizedAlternates("home")}
        prefetch={[
          localizedPath("services", locale),
          localizedPath("portfolio", locale),
          localizedPath("blog", locale),
        ]}
        jsonLd={[
          organizationJsonLd(),
          webSiteJsonLd(),
          professionalServiceJsonLd(services),
        ]}
      />
      <Hero />
      <CampaignTimeline placement="home" />
      {loadBelowFold ? (
        <Suspense
          fallback={
            <div className="min-h-[180rem] bg-background" aria-hidden="true" />
          }
        >
          <HomeBelowFold />
        </Suspense>
      ) : (
        <div className="min-h-[180rem] bg-background" aria-hidden="true" />
      )}
    </>
  );
}
